/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Action_DduInputs */

const en_colleague_action_ddu = /** @type {(inputs: Colleague_Action_DduInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DDU`)
};

const ja_colleague_action_ddu = /** @type {(inputs: Colleague_Action_DduInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DDU`)
};

const fr_colleague_action_ddu = /** @type {(inputs: Colleague_Action_DduInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DDU`)
};

const de_colleague_action_ddu = /** @type {(inputs: Colleague_Action_DduInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DDU`)
};

/**
* | output |
* | --- |
* | "DDU" |
*
* @param {Colleague_Action_DduInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_action_ddu = /** @type {((inputs?: Colleague_Action_DduInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Action_DduInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_action_ddu(inputs)
	if (locale === "ja") return ja_colleague_action_ddu(inputs)
	if (locale === "fr") return fr_colleague_action_ddu(inputs)
	return de_colleague_action_ddu(inputs)
});